module.exports = __webpack_public_path__ + "img/kuaishou.e4141775.png";